/* eslint-disable max-classes-per-file */
import * as axiosAPI from './codegen/typescript-axios';

type StandardBotsAPIConfig = {
  url: string;
  token?: string;
  robotKind?: 'live' | 'simulated';
};

class BrakesAPI extends axiosAPI.MovementBrakesApi {
  public brake() {
    return this.setBrakesState({ state: 'engaged' });
  }

  public unbrake() {
    return this.setBrakesState({ state: 'disengaged' });
  }

  public estop(reason: string = '') {
    return this.engageEmergencyStop({ reason });
  }
}

class RoutinesVariablesAPI extends axiosAPI.RoutineEditorVariablesApi {}

class RoutinesAPI {
  public constructor(private config: axiosAPI.Configuration) {}

  public get routines() {
    return new axiosAPI.RoutineEditorRoutinesApi(this.config);
  }

  public get variables() {
    return new RoutinesVariablesAPI(this.config);
  }
}

class ChatGPTAPI extends axiosAPI.ChatGPTDataApi {}

class TeleopAPI extends axiosAPI.TeleopApi {}

class RecorderAPI extends axiosAPI.RecorderApi {}

class WebRTCAPI extends axiosAPI.WebrtcApi {}

class CameraBotAPI extends axiosAPI.CameraBotApi {}

class MovementPositionControlledAPI extends axiosAPI.MovementPositionControlledApi {}

class SpaceAPI extends axiosAPI.SpaceApi {}

class IOControlAPI extends axiosAPI.IOControlApi {}

class IOStatusAPI extends axiosAPI.IOStatusApi {}

export class StandardBotsSDK {
  public constructor(private readonly config: StandardBotsAPIConfig) {}

  private getAxiosConfig(): axiosAPI.Configuration {
    return {
      basePath: this.config.url,
      apiKey: this.config.token,
      isJsonMime: () => true,
      baseOptions: {
        headers: {
          'robot-kind': this.config.robotKind ?? 'simulated',
        },
      },
    };
  }

  public get brakes(): BrakesAPI {
    return new BrakesAPI(this.getAxiosConfig());
  }

  public get routines(): RoutinesAPI {
    return new RoutinesAPI(this.getAxiosConfig());
  }

  public get chatgpt(): ChatGPTAPI {
    return new ChatGPTAPI(this.getAxiosConfig());
  }

  public get teleop(): TeleopAPI {
    return new TeleopAPI(this.getAxiosConfig());
  }

  public get recorder(): RecorderAPI {
    return new RecorderAPI(this.getAxiosConfig());
  }

  public get webrtc(): WebRTCAPI {
    return new WebRTCAPI(this.getAxiosConfig());
  }

  public get cameraBot(): CameraBotAPI {
    return new CameraBotAPI(this.getAxiosConfig());
  }

  public get movementPositionControlled(): MovementPositionControlledAPI {
    return new MovementPositionControlledAPI(this.getAxiosConfig());
  }

  public get space(): SpaceAPI {
    return new SpaceAPI(this.getAxiosConfig());
  }

  public get ioControl(): IOControlAPI {
    return new IOControlAPI(this.getAxiosConfig());
  }

  public get ioStatus(): IOStatusAPI {
    return new IOStatusAPI(this.getAxiosConfig());
  }
}
